import Box from '../components/Box';
import Container from '../components/Container';
import Row from '../components/Row';
import ShoppingCart from '../components/ShoppingCart';
import { useAppContext } from '../context/AppContext';
import FullWidthLayout from '../layouts/FullWidthLayout';
import BackArrow from '../components/BackArrow';
import Checkout from '../pages/Checkout';
import { useEffect, useState } from 'react';
import * as Api from '../services/api';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../config/routes';

const CartPage = () => {
  const { andee, cart, setCart, canCheckout, setCanCheckout } = useAppContext();
  const [confirmedEnabled, setConfirmationEnabled] = useState(false);
  const isMobile = window.innerWidth < 768;
  const navigate = useNavigate();

  // swap flex direction so mobile shows the cart before checkout
  const flexDirection = isMobile ? 'column-reverse' : 'row';

  useEffect(() => {
    if (!canCheckout) {
      navigate(ROUTES.MARKETPLACE);
    }
  }, []);

  const confirmAndPay = async () => {
    const { tags } = cart;
    try {
      await Api.purchaseTags(andee, tags);
    } catch (e) {
      console.error(e);
      // TODO: handle error
    }
  };

  const handleRemoveFromCart = (tag) => {
    Api.removeFromCart(cart, tag)
      .then(newCart => setCart(newCart))
      .catch(e => {
        // TODO: error handling
      });
  };

  return (
    <FullWidthLayout>
      <Container>
        <BackArrow />
        <Row gap={100} flexDirection={flexDirection}>
          <Box title="Checkout" padding={0} style={{ flexGrow: 1 }}
          >
            <Checkout
              onComplete={() => setConfirmationEnabled(true)}
            />
          </Box>
          <Box title="Cart" padding={0} style={{
            minWidth: 500,
            maxWidth: '100%',
            width: 'auto'
          }}>
            <ShoppingCart
              cart={cart}
              buttonDisabled={confirmedEnabled === false || !canCheckout}
              onButtonClick={confirmAndPay}
              setCanCheckout={setCanCheckout}
              onRemoveFromCart={handleRemoveFromCart}
            />
          </Box>
        </Row>
      </Container>
    </FullWidthLayout>
  );
};

export default CartPage;
